import { IsString, ValidateNested } from 'class-validator';
import { IsNotEmpty } from 'class-validator';
import { ChallengeDayDto } from './challenges-day.dto';
import { ChallengesStatsDto } from './challenges-stats.dto';
import { FileDto } from './file.dto';
import { UserDto } from './user.dto';

export class UserToChallengeDayDto {
	id: string;
	userId: string;
	challengeDayId: string;
	userToChallengeWeekId: string;
	stats: ChallengesStatsDto;
	feedbackImageId?: string;
	feedback?: string;
	completedAt?: Date;
	allowed: boolean;
	journalForeignId?: string;

	createdAt: Date;
	updatedAt: Date;
	deletedAt?: Date;

	user?: UserDto;
	challengeDay?: ChallengeDayDto;
	feedbackImage?: FileDto;
}

export class CreateUserToChallengeDayDto {
	userId: string;
	challengeDayId: string;
	userToChallengeWeekId: string;
	stats: ChallengesStatsDto;
	feedback?: string;
	feedbackImageId?: string;
	allowed: boolean;
}

export class CompleteChallengeDayDto {
	@ValidateNested()
	stats: ChallengesStatsDto;

	@IsString()
	@IsNotEmpty()
	journalForeignId: string;

	@IsString()
	feedback?: string;

	@IsString()
	feedbackImageId?: string;
}
